import { useState } from "react";
import { toast } from "react-toastify";
import {
  getTipos,
  uploadDocumentoApi,
  getCategorias,
  getDocumentos,
  viewPDF,
  downloadPDF,
} from "../../api/baseDocumental/baseDocumentalApi";

const useBaseDocumental = () => {
  const [loading, setLoading] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [tipo, setTipo] = useState("");
  const [subtipo, setSubtipo] = useState("");
  const [palabrasClave, setPalabrasClave] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [tipos, setTipos] = useState([]);
  const [subtipos, setSubtipos] = useState([]);

  const [categorias, setCategorias] = useState({});
  const [tiposSeleccionados, setTiposSeleccionados] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(20);

  // -----------------------------
  //   TIPOS / SUBTIPOS
  // -----------------------------
  const loadTipos = async () => {
    try {
      const data = await getTipos();
      if (Array.isArray(data)) {
        const padres = data.filter((item) => item.padre === "0");
        setTipos(padres);
        localStorage.setItem("tiposData", JSON.stringify(data));
      }
    } catch {
      toast.error("Error cargando tipos y subtipos");
    }
  };

  const handleTipoChange = (value) => {
    setTipo(value);
    setSubtipo("");

    const allData = JSON.parse(localStorage.getItem("tiposData")) || [];
    const hijos = value ? allData.filter((i) => i.padre === value) : [];
    setSubtipos(hijos);
  };

  // -----------------------------
  //   SUBIR DOCUMENTO
  // -----------------------------
  const uploadDocumento = async () => {
    if (!titulo || !tipo || !subtipo || !palabrasClave || !archivo) {
      toast.error("Por favor completa todos los campos.");
      return false;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("tipo", tipo);
      formData.append("subtipo", subtipo);
      formData.append("palabras_clave", palabrasClave);
      formData.append("usuario", "C9A646A2-9C62-4FF9-97E2-5E409F108725");
      formData.append("archivo", archivo);

      const result = await uploadDocumentoApi(formData);

      if (result.success) {
        toast.success("Documento cargado correctamente.");
        resetForm();
        return true;
      } else {
        toast.error(result.message || "Error al subir el documento.");
        return false;
      }
    } catch {
      toast.error("Error al conectar con el servidor.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setTitulo("");
    setTipo("");
    setSubtipo("");
    setPalabrasClave("");
    setArchivo(null);
    setSubtipos([]);
  };

  // -----------------------------
  //   CATEGORÍAS
  // -----------------------------
  const loadCategorias = async () => {
    try {
      const data = await getCategorias();
      const estructura = {};

      const padres = data.filter((i) => i.padre === "0");
      padres.forEach((p) => {
        estructura[p.descripcion] = data
          .filter((h) => h.padre === p.hijo)
          .map((sub) => ({ id: sub.hijo, nombre: sub.descripcion }));
      });
      setCategorias(estructura);
    } catch {
      console.error("Error al cargar categorías");
    }
  };

  // -----------------------------
  //   DOCUMENTOS / FILTROS
  // -----------------------------
  const fetchDocumentos = async () => {
    try {
      const mime = "application/pdf";
      const tipos = tiposSeleccionados.join(",");

      const result = await getDocumentos(keyword, tipos, page, limit, mime);

      if (result.success) setDocumentos(result.data);
      else setDocumentos([]);
    } catch (err) {
      console.error("Error al cargar documentos", err);
    }
  };

  // -----------------------------
  //   PDF (ver / descargar)
  // -----------------------------
  const handleViewPDF = async (filename) => {
    try {
      const res = await viewPDF(encodeURIComponent(filename));
      if (!res.ok) throw new Error();

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch {
      toast.error("No se pudo visualizar el archivo");
    }
  };

  const handleDownloadPDF = async (filename, originalName) => {
    try {
      const res = await downloadPDF(encodeURIComponent(filename));
      if (!res.ok) throw new Error();

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = originalName;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("No se pudo descargar el archivo");
    }
  };

  return {
    // Modal
    titulo,
    setTitulo,
    tipo,
    setTipo,
    subtipo,
    setSubtipo,
    palabrasClave,
    setPalabrasClave,
    archivo,
    setArchivo,
    tipos,
    subtipos,
    loadTipos,
    handleTipoChange,
    uploadDocumento,
    loading,
    resetForm,

    // Listado y filtros
    categorias,
    loadCategorias,
    keyword,
    setKeyword,
    documentos,
    fetchDocumentos,
    tiposSeleccionados,
    toggleTipo: (id) => {
      setTiposSeleccionados((prev) =>
        prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
      );
    },
    isGroupSelected: (s) => s.every((i) => tiposSeleccionados.includes(i.id)),
    handleParentToggle: (s) => {
      const allSelected = s.every((i) => tiposSeleccionados.includes(i.id));
      s.forEach((i) => {
        setTiposSeleccionados((prev) =>
          allSelected ? prev.filter((t) => t !== i.id) : [...prev, i.id]
        );
      });
    },
    page,
    setPage,

    // PDF
    handleViewPDF,
    handleDownloadPDF,
  };
};

export default useBaseDocumental;

